import React, { Component } from 'react'
import { Link } from 'react-router-dom'
// css
import './DownloadHeader.css'

class Header extends Component {
  render () {
    return (
      <div id='download-header'>
        <div className='header-outer-blk noselect'>
          <div className='download-logo-blk'>
            <Link to='/'>
              <img src={process.env.PUBLIC_URL + '/assets/images/logo.svg'} className='download-logo-img' alt='logo' />
            </Link>
            <div className='hr-line' />
            <p>Download</p>
          </div>
        </div>
      </div>
    )
  }
}

export default Header
